import { Box, Table, Thead, Tbody, Th, Tr, Td, Flex, IconButton } from "@chakra-ui/react";
import {
  SortOrder,
  useDeleteQuestionMutation,
  useQuestionsQuery,
} from "../../generated/graphql";
import {
  FcRefresh,
  FcDatabase,
  FcPlus,
  FcEditImage,
  FcApproval,
  FcCancel,
  FcAbout,
} from "react-icons/fc";
import dayjs from "dayjs";
import DeleteItem from "../../components/delete/DeleteItem";
import Loading from "../../components/loading/Loading";
import Error from "../../components/error/Error";
import PageLayout from "../../components/ui/PageLayout";
import { Link } from "react-router-dom";
import Description from "../../components/description/Description";

const All = () => {
  const [deleteQuestion] = useDeleteQuestionMutation();

  const { loading, error, data, refetch } = useQuestionsQuery({
    variables: {
      orderBy: {
        category: {
          order: SortOrder.asc,
        },
      },
    },
    fetchPolicy: "network-only",
  });
  if (loading) {
    return <Loading />;
  }
  if (error) {
    return <Error error={error} />;
  }

  const handleDelete = async (id: string) => {
    try {
      await deleteQuestion({
        variables: {
          where: {
            id,
          },
        },
      });
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <PageLayout>
      <Flex
        mb={6}
        justifyContent={"space-between"}
        alignItems="center"
        bgColor={"gray.100"}
        padding={2}
        rounded="md"
      >
        <Box fontSize={"18px"} fontWeight="bold">
          Questions
        </Box>
        <Flex experimental_spaceX={4}>
          <IconButton
            icon={<FcRefresh />}
            aria-label="Refetch Query"
            onClick={() => refetch()}
          />
          <IconButton
            to={`/question/create`}
            as={Link}
            icon={<FcPlus />}
            aria-label="Add Item"
            onClick={() => refetch()}
          />
        </Flex>
      </Flex>
      <Table>
        <Thead>
          <Tr>
            <Th>#</Th>
            <Th>Descriptions</Th>
            <Th textAlign={"center"}>Choices</Th>
            <Th textAlign={"center"}>Answers</Th>

            <Th textAlign={"center"}>Content</Th>

            <Th textAlign={"center"}>Action</Th>
          </Tr>
        </Thead>
        <Tbody>
          {data?.questions.map((question, i) => {
            return (
              <Tr key={i}>
                <Td>{i + 1}</Td>
                <Td minWidth={"300px"}>
                  <Description
                    field="question"
                    id={question.id}
                    descriptions={question.descriptions}
                    refetch={refetch}
                  />
                </Td>
                <Td textAlign={"center"}>{question._count?.choices} Choice(s)</Td>

                <Td textAlign={"center"}>{question._count?.answers} Answer(s)</Td>

                <Td textAlign={"center"}>
                  <IconButton
                    aria-label="Content Section"
                    as={Link}
                    to={`/content/question/${question.id}`}
                    icon={<FcDatabase />}
                  />
                </Td>
                <Td>
                  <Flex justifyContent={"center"}>
                    <Box mx={2}>
                      <IconButton
                        aria-label="Edit"
                        icon={<FcAbout />}
                        as={Link}
                        to={`/question/detail/${question.id}`}
                      />
                    </Box>
                    <Box mx={2}>
                      <IconButton
                        aria-label="Edit"
                        icon={<FcEditImage />}
                        as={Link}
                        to={`/question/update/${question.id}`}
                      />
                    </Box>
                    <Box mx={2}>
                      <DeleteItem
                        id={question.id}
                        refetch={refetch}
                        title={`${question.descriptions[0].title}`}
                        handleDelete={handleDelete}
                      />
                    </Box>
                  </Flex>
                </Td>
              </Tr>
            );
          })}
        </Tbody>
      </Table>
    </PageLayout>
  );
};

export default All;
